"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornFeatureRoutes = void 0;
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var AcornFeatureContainer_1 = require("./AcornFeatureContainer");
var authentication_1 = require("./authentication");
var AcornFeatureRoutes = function () {
    var featureContext = AcornFeatureContainer_1.useFeatureContext();
    return (react_1.default.createElement(react_router_1.Switch, null, featureContext.features
        // This sort orders features with longer paths to the front of the queue to ensure that they
        // trump shorter, but more permissive, route matches.
        .sort(function (a, b) { return (a.path.length < b.path.length ? 1 : -1); })
        .map(function (feature) { return (react_1.default.createElement(authentication_1.GuardedRoute, { key: feature.name, requiredPermissions: feature.requiredPermissions, path: feature.path, exact: false, render: function () { return react_1.default.createElement(feature.component, __assign({}, feature.componentProps)); } })); })));
};
exports.AcornFeatureRoutes = AcornFeatureRoutes;
//# sourceMappingURL=AcornFeatureRoutes.js.map